import axios from "axios";
import { getApiHeaders } from "../../api/apiHeaders";
import { updateStock, updateOption } from "./eventActions";
import { config } from "../../config";

const url_api = config.api.web;

export const loadStockQuotes = (data) => async (dispatch) => {
    const symbols = (data.symbols || []).filter(Boolean);
    if (!symbols.length || !data.user_id) return;

    try {
        const response = await axios.get(url_api + "market/quotes", {
            params: {
                symbols: symbols.join(","),
                id: data.user_id,
            },
            headers: getApiHeaders(),
        });

        if (response.status < 300 && response.data.status === "Success") {
            const quotes = response.data.body?.quotes || {};
            Object.values(quotes).forEach((quote) => {
                if (quote && quote.sym) {
                    dispatch(updateStock(quote));
                }
            });
        }
    } catch (error) {
        console.error("loadStockQuotes", error.response?.data?.body || error.message);
    }
};

export const loadOptionQuotes = (data) => async (dispatch) => {
    const tickers = (data.tickers || []).filter(Boolean);
    if (!tickers.length || !data.user_id) return;

    try {
        const response = await axios.get(url_api + "market/option-quotes", {
            params: {
                tickers: tickers.join(","),
                id: data.user_id,
            },
            headers: getApiHeaders(),
        });

        if (response.status < 300 && response.data.status === "Success") {
            const quotes = response.data.body?.quotes || {};
            Object.values(quotes).forEach((quote) => {
                if (quote && quote.sym) {
                    dispatch(updateOption(quote));
                }
            });
        }
    } catch (error) {
        console.error("loadOptionQuotes", error.response?.data?.body || error.message);
    }
};
